import {useQueryVessels} from '../query/vessels/vessels'

export function useHasActiveVessels(options?: {suspense: boolean}): boolean {
    const {data: vessels} = useQueryVessels({}, {suspense: options?.suspense ?? false})
    const hasActiveVessel = vessels?.some((vessel) => vessel.status === 'ACTIVE')

    return Boolean(hasActiveVessel)
}
